import Modal from 'bootstrap/js/dist/modal'

export default class ModalContactUs {
  constructor(element) {
		const button = document.getElementById('recruitment-contact-us');
		const modal = new Modal(element)

		if (button) {
			button.addEventListener('click', () => {
				modal.show()
			});
		}
  }
}